export default defineNuxtPlugin(nuxtApp => {
    nuxtApp.provide('can', nuxtApp.$abilitySingleton.can)
})
